import { create } from "zustand";

const useStashwiseStore = create((set) => ({
  user: {},
  otp: "",
  holdId: "",
  menuOpen: false,
  modals: {},
  openModal: false,
  pin: "",
  savingsFormData: {},
  account: "",
  setSavingsFormData: (value) => set({ savingsFormData: value }),
  setPin: (value) => set({ pin: value }),
  setUser: (user) => set({ user: user }),
  setVerifyOTP: (otp) => set({ otp: otp }),
  cards: [],
  setCard: (card) => set({ cards: card }),
  setMenuOpen: (value) => set({ menuOpen: value }),
  setHoldId: (value) => set({ holdId: value }),
  setOpenModal: (modalId, value) =>
    set((state) => ({
      modals: { ...state.modals, [modalId]: value },
    })),
  setAccount: (value) => set({ account: value }),
}));

export default useStashwiseStore;
